/**
 * The public URL of one event: `/evenimente/<slug>`.
 *
 * The slug comes straight from the API — the backend assigns it once, at creation, from the
 * title, and never recomputes it afterwards, the same guarantee news/pages/policies already had
 * via content_item.slug. Events used to have no such column, which is why this used to compute a
 * slug from the title at render time and append the id to it for uniqueness; now that the backend
 * guarantees both, this is exactly the /stiri/:slug pattern.
 */
export function eventPath(event: { slug: string }): string {
  return `/evenimente/${event.slug}`;
}
